import React, { Component } from "react";
import { Modal, Button, Row } from "react-bootstrap";
import { connect } from "react-redux";
import { ModalButton } from "../ModalButton";
import withFetchHook from "../withFetchHook";

class SendSMSModal extends Component {
  constructor(props) {
    super(props)
    this.state = { phone: !!props.phone ? props.phone.replace('(', '').replace(')', '').replace('-', '').replace(' ','') : ''  }
   }

  handleClose() {
    this.props.closeModal();
  }

  sendSms() {
    this.setState({sending: true})
    const { sendSmsFailed } = this.props;
    this.props.fetch(`/organizations/${this.props.organizationName}/residents/${this.props.resident.id}/send_code_sms.json`, {
      method: 'POST',
      data: {
        code: this.props.signupCode,
        phone: this.state.phone,
      }
    }).then((data) => {
      if (data.errors)
        sendSmsFailed({errors: [data.errors]})
      this.setState({
        sending: false,
      });
      this.props.closeModal();
    });

  }

  handleChange(event) {
    event.preventDefault()
    this.setState({phone: event.target.value.replace(/-|\s/g,"")})
  }

  render() {
    return (
      <Modal show={this.props.show} onHide={this.handleClose.bind(this)}>
        <Modal.Header closeButton>
          <Modal.Title>Send SMS</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <label>
            What phone number would you like to send the sign up code to?
          </label>
          { this.state.phone }
          <input
            className="form-control"
            type="number"
            name="name"
            value={this.state.phone}
            onKeyDown={(evt)=> ['e','-','.'].includes(evt.key) && evt.preventDefault()}
            onChange={this.handleChange.bind(this)} />
        </Modal.Body>
        <Modal.Footer>
        <Button
            variant="info"
            disabled={this.state.sending}
            onClick={this.sendSms.bind(this)}>
            Send
          </Button>

          <Button
            variant="info"
            onClick={() => this.props.closeModal()}>
            Cancel
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    organizationName: state.organization.name,
    resident: state.resident,
    show: state.ui.sendSMSModal.show,
    phone: state.resident.phone,
    sending: false,
  };
}

const mapDispatchToProps = (dispatch) => {
  return {
    closeModal: () => dispatch({ type: "CLOSE_RESOURCE_MODAL", payload: { resourceName: "sendSMS" }}),
    sendSmsFailed: (errors) => dispatch({ type: "UPDATE_ERRORS", payload: { errors } }),
  };
}

export default withFetchHook(connect(mapStateToProps, mapDispatchToProps)(SendSMSModal));
